<template>
  <div v-if='!invoices || invoices.length == 0'>
    <h2 class="message">
      <i class="material-icons">credit_card</i>
      <span>{{ $t('backups.lonely') }}</span>
    </h2>
  </div>

  <div v-else id="listing" class="list">
  <h2 v-if="invoices || invoices.length > 0">{{ $t('files.files') }}</h2>
  <div v-if="invoices || invoices.length > 0" class="invoicelist">
    <item :ref="item.id" v-for="(item) in invoices"
      :key="base64(item.id)"
      v-bind:id="item.id"
      v-bind:ctime="item.ctime"
      v-bind:subject="item.subject"
      v-bind:total="item.total"
      v-bind:paid="item.paid">
    </item>
  </div>
</div>

</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Item from './ListingItemInvoices.vue';
import css from '@/utils/css';

export default {
  name: 'listing',
  components: { Item },
  data: function () {
    return {
      show: 50
    };
  },
  computed: {
    ...mapState(['invoices', 'selected', 'user'])
  },
  mounted: function () {
    // Check the columns size for the first time.
    this.resizeEvent();

    // Add the needed event listeners to the window and document.
    window.addEventListener('keydown', this.keyEvent);
    window.addEventListener('resize', this.resizeEvent);
    window.addEventListener('scroll', this.scrollEvent);
    document.addEventListener('dragover', this.preventDefault);
  },
  beforeDestroy () {
    // Remove event listeners before destroying this page.
    window.removeEventListener('keydown', this.keyEvent);
    window.removeEventListener('resize', this.resizeEvent);
    window.removeEventListener('scroll', this.scrollEvent);
    document.removeEventListener('dragover', this.preventDefault);
  },
  methods: {
    ...mapMutations([ 'updateUser' ]),
    base64: function (name) {
      return window.btoa(unescape(encodeURIComponent(name)));
    },
    preventDefault (event) {
      // Wrapper around prevent default.
      event.preventDefault();
    },
    resizeEvent () {
      // Update the columns size based on the window width.
      let columns = Math.floor(document.querySelector('main').offsetWidth / 300);
      let items = css(['#listing.mosaic .item', '.mosaic#listing .item']);
      if (columns === 0) columns = 1;
      items.style.width = `calc(${100 / columns}% - 1em)`;
    },
    scrollEvent () {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        this.show += 50;
      }
    }
  }
};
</script>
